<div class="container-fluid">
  <div class="col-12">
    <div class="col-12">
      <p i18n="@@addBrokerInstructions" style="text-align: justify">En caso de que cuentes con un código de referido por favor colocalo para validarlo y añadirlo a tu aplicación.</p>
    </div>
    <div class="col-sm-12 col-lg-6">
      <form #codeForm="ngForm" (ngSubmit)="verifyBrokerCode()">
        <label i18n="@@addBrokerCode">Código de referido</label>
        <input class="form-control" type="text" name="code" [(ngModel)]="brokerCode" required>
        <button class="btn btn-outline-primary mt-3" type="submit" i18n="@@associateBroker">Asociar</button>
      </form>
    </div>
  </div>
</div>

<p-dialog header=" " [(visible)]="display" [modal]="true">
  <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
    <p i18n="@@confirmBroker">Confirma a tu referido</p>
    <p>{{validation?.name}}</p>
  </div>
  <div>
    <button type="button" class="btn btn-danger" (click)="display = false" i18n="@@modifyBrokerModal">Corregir</button>
    <button type="button" class="btn btn-success ml-3" (click)="confirmBroker()"  i18n="@@confirmBrokerModal">Confirmar</button>
  </div>
</p-dialog>


